/* eslint-disable no-empty, no-restricted-globals */
import shared from './shared';

export default () => {
  const socialTriggers = document.querySelectorAll('.c-social__more-trigger');

  if (socialTriggers.length < 1) {
    return;
  }

  let activeSocialPopups = [];

  [].forEach.call(socialTriggers, socialTrigger => {
    const moreButtons = socialTrigger.parentNode.querySelector(
      '.c-social__more',
    );

    socialTrigger.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      socialTrigger.classList.toggle(shared.CSS.active);
      moreButtons.classList.toggle(shared.CSS.active);

      if (socialTrigger.classList.contains(shared.CSS.active)) {
        activeSocialPopups.push(socialTrigger);
        activeSocialPopups.push(moreButtons);
      }
    });
  });

  document.body.addEventListener('click', () => {
    if (activeSocialPopups.length > 0) {
      for (let i = 0; i < activeSocialPopups.length; i += 1) {
        activeSocialPopups[i].classList.remove(shared.CSS.active);
      }

      activeSocialPopups = [];
    }
  });
};



// WEBPACK FOOTER //
// ./wp/wp-content/themes/elefint-redesign-chisel/src/scripts/modules/social.js